import { gql } from '@apollo/client';

export const CREATE_PROPOSAL = gql`
  mutation CreateProposal(
    $name: String!
    $brand_id: ID
    $month: String!
    $group_id: ID
    $campaign_type: String
    $influencer_ids: [ID]
  ) {
    createProposal(
      name: $name
      brand_id: $brand_id
      month: $month
      group_id: $group_id
      campaign_type: $campaign_type
      influencer_ids: $influencer_ids
    ) {
      status
      code
      error
      data {
        id
        name
        status
      }
    }
  }
`;

export const UPDATE_PROPOSAL = gql`
  mutation UpdateProposal(
    $id: ID!
    $name: String
    $brand_id: ID
    $money: Float
    $currency: String
    $month: String
    $status: String
    $group_id: ID
    $contract_url: String
    $account_manager_ids: [ID]
    $campaign_type: String
    $influencer_ids: [ID]
  ) {
    updateProposal(
      id: $id
      name: $name
      brand_id: $brand_id
      money: $money
      currency: $currency
      month: $month
      status: $status
      group_id: $group_id
      contract_url: $contract_url
      account_manager_ids: $account_manager_ids
      campaign_type: $campaign_type
      influencer_ids: $influencer_ids
    ) {
      status
      code
      error
      data {
        id
        name
        status
        contract_url
        group_id
        accountManagers {
          id
          name
          profile_picture
        }
        ProposalUsers {
          id
          user_id
          name
          profile_picture
        }
      }
    }
  }
`;

export const UPDATE_PROPOSAL_LOGO = gql`
  mutation UpdateProposalLogo($id: ID!, $file: Upload!) {
    updateProposalLogo(id: $id, file: $file) {
      status
      code
      error
      data {
        id
        logo_url
      }
    }
  }
`;

export const DELETE_PROPOSAL = gql`
  mutation DeleteProposal($id: ID!) {
    deleteProposal(id: $id) {
      status
      code
      error
    }
  }
`;

export const APPROVE_PROPOSAL = gql`
  mutation ApproveProposal($id: ID!) {
    approveProposal(id: $id) {
      status
      code
      error
      data {
        id
        campaign_id
        campaign_recurrent_id
      }
    }
  }
`;

export const LINK_CONTRACT_DOCUMENT = gql`
  mutation LinkContractDocument($proposalId: ID!, $contract_url: String!) {
    linkContractDocument(proposalId: $proposalId, contract_url: $contract_url) {
      status
      code
      error
      data {
        id
        document_id
        signed_at
        proposal_id
      }
    }
  }
`;

export const UPDATE_PROPOSAL_USER_STATUS = gql`
  mutation UpdateProposalUserStatus(
    $id: ID!
    $status: ProposalInfluencerStatus!
  ) {
    updateProposalUserStatus(id: $id, status: $status) {
      status
      code
      error
      data {
        id
        ProposalUsers {
          id
          user_id
          total_amount
          influencer_amount
          influencer_amount_type
          total_variable_amount
          influencer_variable_amount
          influencer_variable_type
          initDate
          finishDate
          status
          accepted_at
          rejected_at
          name
          profile_picture
          actions {
            id
            proposal_user_id
            type
            platform
            description
            hasScript
            hasPreview
            internal_validation
            number_of_action
            month
            variable_type
            total_amount
            total_currency
            influencer_amount
            influencer_currency
          }
        }
      }
    }
  }
`;

export const GENERATE_PROPOSAL_PDF = gql`
  mutation GenerateProposalPdf($proposalId: ID!) {
    generateProposalPdf(proposalId: $proposalId) {
      status
      code
      error
      data {
        id
        pdf_url
      }
    }
  }
`;

export const GENERATE_PROPOSAL_DOC = gql`
  mutation GenerateProposalDoc($proposalId: ID!) {
    generateProposalDoc(proposalId: $proposalId) {
      status
      code
      error
      data {
        id
        drive_document_url
      }
    }
  }
`;

export const SELECT_PROPOSAL_PACK = gql`
  mutation SelectProposalPack($proposalUserId: ID!, $packId: ID) {
    selectProposalPack(proposalUserId: $proposalUserId, packId: $packId) {
      status
      code
      error
      data {
        id
        ProposalUsers {
          id
          selected_pack_id
        }
      }
    }
  }
`;

export const UPDATE_PROPOSAL_USER = gql`
  mutation UpdateProposalUser(
    $id: ID!
    $influencer_amount: Float
    $influencer_amount_type: String
    $total_amount: Float
    $total_variable_amount: Float
    $influencer_variable_amount: Float
    $influencer_variable_type: String
    $initDate: String
    $finishDate: String
    $cicle: Boolean
    $packs: [ProposalPackInput]
  ) {
    updateProposalUser(
      id: $id
      influencer_amount: $influencer_amount
      influencer_amount_type: $influencer_amount_type
      total_amount: $total_amount
      total_variable_amount: $total_variable_amount
      influencer_variable_amount: $influencer_variable_amount
      influencer_variable_type: $influencer_variable_type
      initDate: $initDate
      finishDate: $finishDate
      cicle: $cicle
      packs: $packs
    ) {
      status
      code
      error
      data {
        id
        ProposalUsers {
          id
          influencer_amount
          influencer_amount_type
          total_amount
          total_variable_amount
          influencer_variable_amount
          influencer_variable_type
          initDate
          finishDate
          cicle
          packs {
            id
            proposal_user_id
            name
            position
            total_amount
            influencer_amount
            actions {
              id
              proposal_user_id
              pack_id
              type
              platform
              description
              hasScript
              hasPreview
              internal_validation
              number_of_action
              month
              variable_type
              total_amount
              total_currency
              influencer_amount
              influencer_currency
            }
          }
        }
      }
    }
  }
`;
